'use client'

import { useEffect } from 'react'

/**
 * Rechargement automatique anti-ChunkLoadError.
 *
 * Quand on redéploie le site, les fichiers JS/CSS changent de nom. Un visiteur
 * qui avait une VIEILLE page ouverte demande alors un fichier qui n'existe plus
 * → « ChunkLoadError / Loading chunk failed ». Ce n'est pas un bug : on recharge
 * la page une fois pour lui servir la nouvelle version, de façon invisible.
 * Garde-fou sessionStorage pour ne jamais boucler.
 */
export default function ChunkReload() {
  useEffect(() => {
    // On a bien chargé : on solde un éventuel rechargement précédent.
    const t = setTimeout(() => {
      try { sessionStorage.removeItem('chunk-reloaded') } catch { /* stockage indispo */ }
    }, 4000)

    const estChunk = (msg: string) =>
      /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk/i.test(msg)

    const recharger = () => {
      try {
        if (sessionStorage.getItem('chunk-reloaded')) return
        sessionStorage.setItem('chunk-reloaded', '1')
      } catch { /* si le stockage est indispo, on recharge quand même une fois */ }
      window.location.reload()
    }

    const onError = (e: ErrorEvent) => {
      if (estChunk(e.message || String(e.error?.message || ''))) recharger()
    }
    const onRejet = (e: PromiseRejectionEvent) => {
      const r = e.reason
      if (estChunk(String(r?.message || r || ''))) recharger()
    }

    window.addEventListener('error', onError)
    window.addEventListener('unhandledrejection', onRejet)
    return () => {
      clearTimeout(t)
      window.removeEventListener('error', onError)
      window.removeEventListener('unhandledrejection', onRejet)
    }
  }, [])

  return null
}
